import { map } from 'rxjs/operators/map';
import { AccessPointSerializer } from '../../models';
import ajax from '../../utils/ajax';

class AccessPointService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/status';
  configurationPathGroup = '/networkAsset/airfinder/status/accessPoints';
  deleteConfigurationPath = '/networkAsset/airfinder/status/accessPoint';

  getAll = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(
      map(data => {
        let serializedResponse =
          data &&
          data.response.filter((r)=>{return r.node && r.node.nodeAddress}).map(r => {
            return AccessPointSerializer.normalize(r);
          });
        serializedResponse.filter(a=>a.id).sort((a, b) => a.healthPriority - b.healthPriority);
        return serializedResponse;
      })
    );
  };
  deleteSiteAccessPoint = (siteId, id, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.deleteConfigurationPath
        }/${id}?siteId=${siteId}`,
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}

export default new AccessPointService();



// WEBPACK FOOTER //
// ./src/services/accesspointservice/index.js